export default __webpack_public_path__ + "static/media/Snd_o2.a9d33a49.mp3";